import { render } from "./BasketComponent.vue?vue&type=template&id=ea527a9c"
import script from "./BasketComponent.vue?vue&type=script&lang=js"
export * from "./BasketComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__